// This file was automatically generated from ptdata.model.lab.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.model.lab');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.lab.displayValue = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.textReportResultValue) ? soy.$$escapeHtml(opt_data.textReportResultValue) : soy.$$escapeHtml(opt_data.value) + ((opt_data.isAbnormal && opt_data.abnormalFlag) ? ' ' + soy.$$escapeHtml(opt_data.abnormalFlag) : ''), (opt_data.showCollectedDate) ? ' (' + (soy.$$escapeHtml(opt_data.collectedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.collectedDate)) : '') + ')' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.lab.reference = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.referenceMin && opt_data.referenceMax) ? (opt_data.referenceMin == opt_data.referenceMax) ? soy.$$escapeHtml(opt_data.referenceMin) : soy.$$escapeHtml(opt_data.referenceMin) + ' - ' + soy.$$escapeHtml(opt_data.referenceMax) : (opt_data.referenceMin) ? ((opt_data.isNumericReferenceRange) ? '&gt; ' : '') + soy.$$escapeHtml(opt_data.referenceMin) : (opt_data.referenceMax) ? ((opt_data.isNumericReferenceRange) ? '&lt; ' : '') + soy.$$escapeHtml(opt_data.referenceMax) : '', (opt_data.units) ? ' ' + soy.$$escapeHtml(opt_data.units) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.lab.noteSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.labTest) ? soy.$$escapeHtml(opt_data.labTest.name) + ': ' : '');
  el8.template.ptdata.model.lab.displayValue(opt_data, output);
  if (opt_data.numPrevResults > 0) {
    output.append('  ', (opt_data.showPrevCollectedDates) ? '\n' : '[ ');
    var rList20457 = opt_data.prevResults;
    var rListLen20457 = rList20457.length;
    for (var rIndex20457 = 0; rIndex20457 < rListLen20457; rIndex20457++) {
      var rData20457 = rList20457[rIndex20457];
      if (rData20457) {
        output.append((! (rIndex20457 == 0)) ? ', ' : '');
        el8.template.ptdata.model.lab.displayValue(soy.$$augmentData(rData20457, {showCollectedDate: opt_data.showPrevCollectedDates}), output);
      }
    }
    output.append((! opt_data.showPrevCollectedDates) ? ' ]' : '');
  }
  if (!opt_sb) return output.toString();
};
